<div class="background-split-layout h-full w-full">
    <app-fuse-loading-bar></app-fuse-loading-bar>

    <div class="flex h-full w-full flex-row overflow-hidden">
        <fuse-vertical-navigation
            [ngClass]="isScreenSmall ? '' : 'split-layout'"
            class="dark bg-black print:hidden"
            [mode]="isScreenSmall ? 'over' : 'side'"
            [opened]="!isScreenSmall">
            <ng-container fuseVerticalNavigationContentHeader>
                <div class="flex h-14 items-center sm:pl-5 sm:pt-6">
                    <img
                        class="w-30"
                        src="images/logo/logo-text-on-dark.svg"
                        alt="Logo image" />
                </div>
                <div class="my-6 ml-2 h-px bg-gray-700"></div>
                <div
                    class="relative flex min-w-0 flex-auto flex-col overflow-hidden">
                    <div class="flex flex-auto flex-col overflow-hidden px-2">
                        <ng-container
                            *ngIf="{
                                steps: steps$ | async,
                                index: index$ | async,
                            } as data">
                            @if (data.steps && data.steps.length >= 1) {
                                @for (
                                    step of data.steps;
                                    track i;
                                    let i = $index;
                                    let isLast = $last
                                ) {
                                    <div
                                        class="relative flex h-9 w-full flex-row items-center gap-3 px-2">
                                        @if (
                                            isStepSelected(
                                                data.steps,
                                                data.index,
                                                i
                                            ) === 'PREVIOUS'
                                        ) {
                                            <mat-icon
                                                svgIcon="heroicons_outline:check-circle"
                                                class="text-gc-green icon-size-5"></mat-icon>
                                        } @else {
                                            <div
                                                [class.bg-gc-green]="
                                                    isStepSelected(
                                                        data.steps,
                                                        data.index,
                                                        i
                                                    ) === 'CURRENT'
                                                "
                                                [class.bg-gray-400]="
                                                    isStepSelected(
                                                        data.steps,
                                                        data.index,
                                                        i
                                                    ) === 'NEXT'
                                                "
                                                class="relative ml-1 flex flex-row items-center justify-center rounded-full p-2">
                                                <span
                                                    class="absolute flex transform flex-row items-center justify-center text-sm font-bold text-black">
                                                    <div>
                                                        {{ i + 1 }}
                                                    </div>
                                                </span>
                                            </div>
                                        }
                                        <span
                                            [class.text-gray-400]="
                                                isStepSelected(
                                                    data.steps,
                                                    data.index,
                                                    i
                                                ) === 'NEXT'
                                            "
                                            [class.text-white]="
                                                isStepSelected(
                                                    data.steps,
                                                    data.index,
                                                    i
                                                ) !== 'NEXT'
                                            "
                                            class="w-full text-lg font-bold">
                                            @if (step.translate) {
                                                {{ step.label | transloco }}
                                            } @else {
                                                {{ step.label }}
                                            }
                                        </span>
                                    </div>
                                    @if (
                                        step.children &&
                                        step.children.length === 0 &&
                                        !isLast
                                    ) {
                                        <div
                                            class="item flex h-7 w-full flex-row space-x-1">
                                            <div
                                                class="ml-0.5 h-full w-5 border-r border-gray-400"></div>
                                            <div class="h-full w-full"></div>
                                        </div>
                                    } @else if (
                                        step.children &&
                                        step.children.length >= 1
                                    ) {
                                        <div
                                            class="relative flex w-full flex-row items-center px-2">
                                            <div
                                                class="flex h-full w-6 flex-col"></div>
                                            <div
                                                class="flex h-full w-full flex-col gap-6">
                                                @for (
                                                    category of step.children;
                                                    track j;
                                                    let j = $index;
                                                    let isLast = $last
                                                ) {
                                                    <span
                                                        [class.text-gray-400]="
                                                            isStepSelected(
                                                                data.steps,
                                                                data.index,
                                                                i,
                                                                j
                                                            ) === 'NEXT'
                                                        "
                                                        [class.text-white]="
                                                            isStepSelected(
                                                                data.steps,
                                                                data.index,
                                                                i,
                                                                j
                                                            ) !== 'NEXT'
                                                        "
                                                        class="w-full text-md font-bold">
                                                        {{ category.label }}
                                                    </span>

                                                    @if (
                                                        category.children &&
                                                        category.children
                                                            .length >= 1
                                                    ) {
                                                        <div
                                                            class="relative flex w-full flex-row">
                                                            <div
                                                                class="flex w-full flex-col">
                                                                @for (
                                                                    section of category.children;
                                                                    track k;
                                                                    let k = $index;
                                                                    let isFirst = $first;
                                                                    let isLast = $last
                                                                ) {
                                                                    <div
                                                                        class="flex w-full flex-row gap-3">
                                                                        <div
                                                                            class="relative h-full">
                                                                            @if (
                                                                                isStepSelected(
                                                                                    data.steps,
                                                                                    data.index,
                                                                                    i,
                                                                                    j,
                                                                                    k
                                                                                ) !==
                                                                                'NEXT'
                                                                            ) {
                                                                                <span
                                                                                    [@slideInTop]="
                                                                                        true &&
                                                                                        !isFirst
                                                                                    "
                                                                                    [class.rounded-t-sm]="
                                                                                        isFirst
                                                                                    "
                                                                                    [class.rounded-b-sm]="
                                                                                        isLast ||
                                                                                        isStepSelected(
                                                                                            data.steps,
                                                                                            data.index,
                                                                                            i,
                                                                                            j,
                                                                                            k
                                                                                        ) ===
                                                                                            'CURRENT'
                                                                                    "
                                                                                    [ngClass]="{
                                                                                        'border-gc-green':
                                                                                            isStepSelected(
                                                                                                data.steps,
                                                                                                data.index,
                                                                                                i,
                                                                                                j,
                                                                                                k
                                                                                            ) !==
                                                                                            'NEXT',
                                                                                        'border-gray-400':
                                                                                            isStepSelected(
                                                                                                data.steps,
                                                                                                data.index,
                                                                                                i,
                                                                                                j,
                                                                                                k
                                                                                            ) ===
                                                                                            'NEXT',

                                                                                        'h-1/2':
                                                                                            isStepSelected(
                                                                                                data.steps,
                                                                                                data.index,
                                                                                                i,
                                                                                                j,
                                                                                                k
                                                                                            ) ===
                                                                                                'CURRENT' &&
                                                                                            isStepSelected(
                                                                                                data.steps,
                                                                                                data.index,
                                                                                                i,
                                                                                                j
                                                                                            ) ===
                                                                                                'CURRENT',
                                                                                        'h-full':
                                                                                            isStepSelected(
                                                                                                data.steps,
                                                                                                data.index,
                                                                                                i,
                                                                                                j,
                                                                                                k
                                                                                            ) !==
                                                                                                'CURRENT' ||
                                                                                            isStepSelected(
                                                                                                data.steps,
                                                                                                data.index,
                                                                                                i,
                                                                                                j
                                                                                            ) !==
                                                                                                'CURRENT',
                                                                                    }"
                                                                                    class="absolute z-999 border-x-2"></span>
                                                                            }
                                                                            <span
                                                                                [class.rounded-t-sm]="
                                                                                    isFirst
                                                                                "
                                                                                [class.rounded-b-sm]="
                                                                                    isLast
                                                                                "
                                                                                class="absolute h-full border-x-2 border-gray-400"></span>
                                                                        </div>

                                                                        <span
                                                                            [class.text-gray-400]="
                                                                                isStepSelected(
                                                                                    data.steps,
                                                                                    data.index,
                                                                                    i,
                                                                                    j,
                                                                                    k
                                                                                ) ===
                                                                                'NEXT'
                                                                            "
                                                                            [class.text-white]="
                                                                                isStepSelected(
                                                                                    data.steps,
                                                                                    data.index,
                                                                                    i,
                                                                                    j,
                                                                                    k
                                                                                ) !==
                                                                                'NEXT'
                                                                            "
                                                                            class="my-1 w-full text-xs font-bold">
                                                                            {{
                                                                                section.label
                                                                            }}
                                                                        </span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                }
                                            </div>
                                        </div>
                                    }
                                }
                            }
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <ng-container fuseVerticalNavigationContentFooter>
                <div class="my-6 ml-2 h-px bg-gray-700"></div>
                <div
                    class="ml-5 flex w-full flex-row items-center justify-start gap-2.5">
                    <mat-icon
                        svgIcon="good-circle:help"
                        class="icon-size-4"></mat-icon>
                    <span class="text-base font-bold">Help</span>
                </div>
            </ng-container>

            <ng-container fuseVerticalNavigationFooter>
                <div class="mb-4 flex flex-col px-4">
                    <button
                        mat-menu-item
                        (click)="signOut()"
                        class="my-2 w-full">
                        <div class="flex flex-row gap-4">
                            <mat-icon
                                [svgIcon]="
                                    'heroicons_outline:arrow-right-on-rectangle'
                                "
                                class="text-red-400"
                                >heroicons_outline:arrow-right-on-rectangle</mat-icon
                            >
                            <span class="text-white">
                                {{ 'common.navigation.logout' | transloco }}
                            </span>
                        </div>
                    </button>
                    <div class="mt-4 w-full text-xs">
                        <span>Version 1.0</span>
                    </div>
                    <div class="mt-2 flex w-full flex-row gap-2 text-xs">
                        <a href="dashboard">
                            {{ 'common.navigation.legal' | transloco }}
                        </a>
                        -
                        <a href="dashboard">
                            {{ 'common.navigation.t&c' | transloco }}
                        </a>
                    </div>
                </div>
            </ng-container>
        </fuse-vertical-navigation>

        <div
            class="flex h-full max-h-screen w-full flex-auto flex-row gap-2 overflow-hidden p-2">
            @if ((layout$ | async) !== 'split') {
                <app-good-circle-card class="w-full">
                    <div
                        class="bg-card flex h-full w-full flex-col overflow-y-hidden">
                        @if (true) {
                            <router-outlet></router-outlet>
                        }
                    </div>
                </app-good-circle-card>
            } @else {
                <app-good-circle-card
                    class="flex w-1/2 flex-auto flex-col overflow-hidden rounded-3xl">
                    <div class="bg-card flex h-full w-full flex-col">
                        @if (true) {
                            <router-outlet></router-outlet>
                        }
                    </div>
                </app-good-circle-card>
            }

            @if ((layout$ | async) === 'split') {
                <div class="w-1/2 overflow-hidden rounded-3xl">
                    <ng-template #decorationComponent></ng-template>
                </div>
            }
        </div>
    </div>
</div>
